import Model from 'flarum/common/Model';
export default class ExhibitionFinding extends Model {
  gbifId() {
    return Model.attribute('gbifId').call(this);
  }
  cfId() {
    return Model.attribute('cfId').call(this);
  }
  label() {
    return Model.attribute('label').call(this);
  }
  vernacularName() {
    return Model.attribute('vernacularName').call(this);
  }

  // See ExhibitionFindingResource::fields()'s photos field.
  photos() {
    return Model.attribute('photos').call(this);
  }
  notes() {
    return Model.attribute('notes').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }

  // null when gbifId is 0 or the GBIF lookup failed - cached server-side
  // on gbifId's/cfId's own .set(), see ExhibitionFindingResource::fields()'s
  // speciesDisplay field.
  speciesDisplay() {
    return Model.attribute('speciesDisplay').call(this);
  }
  exhibition() {
    return Model.hasOne('exhibition').call(this);
  }
}
flarum.reg.add('champis-exhibitions', 'common/models/ExhibitionFinding', ExhibitionFinding);